import { render, staticRenderFns } from "./SentimentPill.vue?vue&type=template&id=60645ad5&scoped=true"
import script from "./SentimentPill.vue?vue&type=script&lang=js"
export * from "./SentimentPill.vue?vue&type=script&lang=js"
import style0 from "./SentimentPill.vue?vue&type=style&index=0&id=60645ad5&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60645ad5",
  null
  
)

export default component.exports